/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from 'react';
import {AppHomeDialog} from '../AppHomeTab/AppHomeDialog';
import appHomeData from '../../containers/AppHome/appHomeData';

type Props = {
	intl: any;
	createSpacesCallback: Function;
};

const NewCanvasCard = ({intl, createSpacesCallback}: Props) => {
	const fredNewCanvasData: any = appHomeData.FRED.startRow.tabs[0].links
		? appHomeData.FRED.startRow.tabs[0].links[0]
		: '';
	return (
		<AppHomeDialog
			key={`${fredNewCanvasData.type}-0`}
			text={intl.formatMessage({id: `${fredNewCanvasData.text}`})}
			link={fredNewCanvasData.link}
			imgUrl={fredNewCanvasData.imgUrl}
			type={fredNewCanvasData.type}
			intl={intl}
			createSpacesCallback={createSpacesCallback}
		/>
	);
};

export default NewCanvasCard;
